var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":{ path: _vm.getTo(), query: { city_id: _vm.$route.query.city_id } },"tag":_vm.tag}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }